import React from 'react'

const IconSend = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M3.4165 15.375V4.625L16.9261 10L3.4165 15.375ZM4.49984 13.7708L13.9582 10L4.49984 6.22917V8.66021L8.519 10L4.49984 11.3398V13.7708Z'
        fill='#095BBD'
      />
    </svg>
  )
}

export default IconSend
